import React, { FC, memo } from "react";
import { Text } from "@lookiero/sty-psp-ui";
import { ButtonIcon } from "@lookiero/sty-psp-ui";
import { Header } from "../Header";
import { ButtonIconPlaceholder } from "../buttonIconPlaceholder/ButtonIconPlaceholder";

interface HeaderProps {
  readonly title: string;
  readonly onBack: () => void;
}

const OrderHeader: FC<HeaderProps> = ({ title, onBack }) => (
  <Header testID="order-header">
    <ButtonIcon name="arrow_left" testID="arrow-left-button-icon" onPress={onBack} />
    <Text ellipsizeMode="tail" level={3} numberOfLines={1} style={{ flexShrink: 1 }} variant="action">
      {title}
    </Text>
    <ButtonIconPlaceholder />
  </Header>
);

const MemoizedOrderHeader = memo(OrderHeader);

export { MemoizedOrderHeader as OrderHeader };
